var _path, _path2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.63281L19 6.13281L19.5 9.63281M2 9.63281V24.6328H22V9.63281H19.5M2 9.63281H19.5",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.1328C14 16.0282 14.8954 15.1328 16 15.1328H22V19.1328H16C14.8954 19.1328 14 18.2374 14 17.1328Z",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16.6328,
    width: 1,
    height: 1,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3.5C25 1.567 26.567 0 28.5 0C30.433 0 32 1.567 32 3.5C32 5.433 30.433 7 28.5 7C26.567 7 25 5.433 25 3.5Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.3f7eb58bfb28cddb9e90b8256f568ad9.svg";
export { ForwardRef as ReactComponent };